import { DirectivasModule } from './../directivas.module/directivas.module';
/**
 * Created by rsierra.
 */

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {FilterByPipe} from './util/filter.pipe';
import {RouterModule} from '@angular/router';
import {DataShareService} from './util/data.share';
import {PageNotFoundComponent} from './components/generic/not-found/not-found.component';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {AuthService} from './auth/auth.service';
import {AuthGuardLoged} from './auth/auth-loged.service';
import {AuthServerProvider} from './auth/auth-jwt.service';
import {ModalConfirmComponent} from './components/generic/modal-confirm/modal-confirm.component';
import {Ng2Webstorage} from 'ngx-webstorage';
import {ResourceModule} from '@ngx-resource/handler-ngx-http';
import {DatosCiudadanoComponent} from './components/datos-solicitante/datos-ciudadano.component';
import {DatosAdicionalesComponent} from '../common.module/components/datos.adicionales.component/datos-adicionales.component';
import {LayoutListComponent} from './components/generic/layout-list/layout-list.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ResourceAuth} from './auth/authenticate.resource';
import {RequirementsResource} from './resource/requirements.resource';
import {UploadRequirementsComponent} from './components/upload-requirements.component/upload-requirements.component';
import {ExcelService} from './util/exportxls.service';
import {AuthGuardAdmin} from './auth/auth-guard.admin.service';
import {AuthGuardPortal} from './auth/auth-guard.portal.service';
import {NgProgressInterceptor} from 'ngx-progressbar';
import {PaymentComponent} from './components/payment-component/payment.component';
import {RfcService} from './service/rfc.service';
import {RfcResource} from './resource/rfc.resource';
import {PaidPaymentResource} from './resource/paid-payment.resource';
import {HistoryCommentsComponent} from './components/history-comments/history-comments.component';
import {FormalitiesNotesService} from './components/history-comments/service/formality-notes.service';
import {FormalityNotesResource} from './components/history-comments/service/formality-notes.resource';
import {EventBusService} from './util/event-bus.service';
import {HistoryCommentsAdminComponent} from './components/history-comments/history-comments-admin.component';
import {CommentsModalComponent} from './components/history-comments/comments-modal.component';
import {ListItemsComponent} from './components/list-items/list-items.component';
import {AuthGuardPortalEmployee} from './auth/auth-guard.portal.employee.service';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {BillingComponent} from './components/billing-component/billing-information.component';
import {ReceiptListComponent} from './components/receipt-list-component/receipt-list.component';
import {FormalityValidateResource} from './resource/formalities-validate.resource';
import {AuthGuardContractors} from './auth/auth-guard.contractors.service';
import {AuthGuardProviders} from './auth/auth-guard.providers.service';
import {ResolutiveComponent} from './components/resolutive-component/resolutive-button.component';
import {ResolutiveResource} from './resource/resolutive.resource';
import {ResolutiveService} from './service/resolutive.service';
import {UnlockFrmService} from './service/unlock-formality.service';
import {UnlockFrmResource} from './resource/unlock-formality.resource';
import {MDBBootstrapModulePro} from 'ng-uikit-pro-standard';
import {MainListComponent} from './components/generic/form-base/main-list.component';
import {ItemsListComponent} from './components/generic/form-base/items-list/items-list.component';
import {CreationModalComponent} from './components/generic/form-base/creation-modal/creation-modal.component';
import {UpdateModalComponent} from './components/generic/form-base/update-modal/update-modal.component';
import {CreationFormComponent} from './components/generic/form-base/creation-form/creation-form.component';
import {AgmCoreModule} from '@agm/core';
import {LoginCitizenComponent} from '../main-portal.component/login.component/login.component';
import {AuthGuardInbox} from './auth/auth-guard.inbox';
import {ResourceGlobalConfig, ResourceQueryMappingMethod} from '@ngx-resource/core';
import {ZonaService} from './service/zona.service';
import {ZonaResource} from './service/zona.resource';
import {MdbCalendarComponent} from './components/calendar/calendar.component';
import {MdbCalendarListViewComponent} from './components/calendar-list-view/calendar-list-view.component';
import {MdbCalendarWeekViewComponent} from './components/calendar-week-view/calendar-week-view.component';
import {MdbCalendarMonthViewComponent} from './components/calendar-month-view/calendar-month-view.component';
import {EventModalComponent} from './components/event-modal/event-modal.component';
import {ProviderFormatComponent} from './components/upload-requirements.component/visor/provider-pdf-format.component';
import {CustomHammerConfig, NgxGalleryModule} from 'ngx-gallery';
import {HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VentanillaUnicaService } from './service/ventanilla-unica.service';
import { VentanillaUnicaResource } from './resource/ventanilla-unica.resource';


import { PersonaBoletinadaComponent } from '../admin.persona-boletinada.module/persona-boletinada/persona-boletinada.component';
import { PersonaBoletinadaResource } from '../admin.persona-boletinada.module/service/persona-boletinada.resource';
import { PersonaBoletinadaService } from '../admin.persona-boletinada.module/service/persona-boletinada.service';
import { environment } from 'src/environments/environment';
import { NoAccentFormDirective } from './util/no-accent.directive';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// Configuracion global para el envio de los query params.
ResourceGlobalConfig.queryMappingMethod = ResourceQueryMappingMethod.None;

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    MDBBootstrapModule.forRoot(),
    MDBBootstrapModulePro.forRoot(),
    Ng2Webstorage.forRoot({prefix: 'mcp', separator: '-'}),
    ResourceModule.forRoot(),
    PerfectScrollbarModule,
    AgmCoreModule.forRoot({
      apiKey: environment.gKey
    }),
    DirectivasModule,
    NgxGalleryModule,
    PdfViewerModule
  ],
  exports: [
    HttpModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MDBBootstrapModule,
    DatosCiudadanoComponent,
    MDBBootstrapModulePro,
    Ng2Webstorage,
    ResourceModule,
    FilterByPipe,
    ModalConfirmComponent,
    PageNotFoundComponent,
    UploadRequirementsComponent,
    PaymentComponent,
    HistoryCommentsComponent,
    HistoryCommentsAdminComponent,
    ListItemsComponent,
    BillingComponent,
    ReceiptListComponent,
    ResolutiveComponent,
    MainListComponent,
    ItemsListComponent,
    CreationModalComponent,
    UpdateModalComponent,
    CreationFormComponent,
    LoginCitizenComponent,
    MdbCalendarComponent,
    MdbCalendarWeekViewComponent,
    MdbCalendarMonthViewComponent,
    MdbCalendarListViewComponent,
    EventModalComponent,
    ProviderFormatComponent,
    NoAccentFormDirective
  ],
  declarations: [
    FilterByPipe,
    DatosCiudadanoComponent,
    DatosAdicionalesComponent,
    ModalConfirmComponent,
    PageNotFoundComponent,
    LayoutListComponent,
    UploadRequirementsComponent,
    PaymentComponent,
    HistoryCommentsComponent,
    HistoryCommentsAdminComponent,
    CommentsModalComponent,
    ListItemsComponent,
    BillingComponent,
    ReceiptListComponent,
    ResolutiveComponent,
    MainListComponent,
    ItemsListComponent,
    CreationModalComponent,
    UpdateModalComponent,
    CreationFormComponent,
    LoginCitizenComponent,
    ProviderFormatComponent,
    MdbCalendarComponent,
    EventModalComponent,
    MdbCalendarWeekViewComponent,
    MdbCalendarMonthViewComponent,
    MdbCalendarListViewComponent,
    NoAccentFormDirective
  ],

  providers: [
    PersonaBoletinadaResource,
    PersonaBoletinadaService,
    DataShareService,
    AuthGuardAdmin,
    AuthGuardPortal,
    AuthGuardPortalEmployee,
    AuthGuardLoged,
    AuthGuardInbox,
    ResourceAuth,
    AuthServerProvider,
    AuthService,
    RequirementsResource,
    ExcelService,
    RfcService,
    RfcResource,
    PaidPaymentResource,
    AuthGuardProviders,
    AuthGuardContractors,
    // ProvidersService,
    // ProvidersResource,
    // RequestsService,
    // RequestsResource,
    ResolutiveResource,
    ResolutiveService,
    UnlockFrmResource,
    UnlockFrmService,
    ZonaService,
    ZonaResource,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NgProgressInterceptor,
      multi: true
    },
    FormalitiesNotesService,
    FormalityNotesResource,
    VentanillaUnicaResource,
    VentanillaUnicaService,
    EventBusService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig},
    FormalityValidateResource,
  ]
})
export class AppCommonLibsModule {
}
